<template>
  <div class="auth-backdrop">
    <div class="auth-modal">
      <h2 class="auth-title">Autorización requerida</h2>
      <p class="auth-subtitle">
        Por favor ingrese su nombre y el código de autorización para utilizar la aplicación.
      </p>

      <form @submit.prevent="submitAuth" class="auth-form">
        <div class="auth-field">
          <label for="nombre">Escribe tu nombre</label>
          <input
            id="nombre"
            v-model="authNombre"
            type="text"
            autocomplete="off"
            :disabled="authLoading"
          />
        </div>

        <div class="auth-field">
          <label for="pin">Inserte código de autorización</label>
          <input
            id="pin"
            v-model="authPin"
            type="password"
            autocomplete="off"
            :disabled="authLoading"
          />
        </div>

        <p v-if="authError" class="auth-error">{{ authError }}</p>

        <button type="submit" class="auth-button" :disabled="authLoading">
          {{ authLoading ? 'Verificando…' : 'Acceder' }}
        </button>
      </form>

      <div class="auth-footer">
        <button type="button" class="auth-mini" @click="$emit('force-offline')">
          Usar sin validación (solo si desactivas VUE_APP_ACCESS_VALIDATION_ENABLED)
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { verifyPin, writeAuth } from '@/utils/auth';

export default {
  name: 'AuthGate',
  emits: ['authorized', 'force-offline'],
  props: {
    initialNombre: { type: String, default: '' },
    initialPin: { type: String, default: '' },
  },
  data() {
    return {
      authNombre: this.initialNombre,
      authPin: this.initialPin,
      authLoading: false,
      authError: '',
    };
  },
  methods: {
    async submitAuth() {
      this.authError = '';
      if (!this.authNombre || !this.authPin) {
        this.authError = 'complete todos los datos antes de enviar';
        return;
      }

      this.authLoading = true;
      try {
        const data = await verifyPin({ nombre: this.authNombre, pin: this.authPin });

        if (data?.success === 'ok') {
          writeAuth({ nombre: this.authNombre, pin: this.authPin });
          this.$emit('authorized', { nombre: this.authNombre });
        } else if (data?.success === 'error') {
          this.authError = data.menssage || 'Error en la verificación del pin.';
        } else {
          this.authError = 'Respuesta inesperada del servidor.';
        }
      } catch (e) {
        console.error('Error verificando pin:', e);
        this.authError = 'No se ha podido verificar el pin. Verifique su conexión e intente nuevamente.';
      } finally {
        this.authLoading = false;
      }
    },
  },
};
</script>

<style scoped>
/* Estilo idéntico al modal original (ligeramente limpiado) */
.auth-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.auth-modal {
  background: #1f2430;
  color: #ffffff;
  padding: 2rem 2.25rem;
  border-radius: 14px;
  max-width: 420px;
  width: 90%;
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.5);
  text-align: left;
}

.auth-title {
  margin: 0 0 0.5rem 0;
  font-size: 1.4rem;
  letter-spacing: 0.03em;
}

.auth-subtitle {
  margin: 0 0 1.5rem 0;
  font-size: 0.9rem;
  opacity: 0.85;
}

.auth-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.auth-field {
  display: flex;
  flex-direction: column;
}

.auth-field label {
  font-size: 0.8rem;
  margin-bottom: 0.25rem;
  opacity: 0.9;
}

.auth-field input {
  padding: 0.45rem 0.7rem;
  border-radius: 8px;
  border: 1px solid #3a3f4c;
  background: #151824;
  color: #ffffff;
  font-size: 0.9rem;
  outline: none;
}

.auth-field input:focus {
  border-color: #00bcd4;
  box-shadow: 0 0 0 1px rgba(0, 188, 212, 0.5);
}

.auth-field input:disabled {
  opacity: 0.7;
}

.auth-error {
  margin: 0;
  font-size: 0.8rem;
  color: #ff6b6b;
}

.auth-button {
  margin-top: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  font-size: 0.9rem;
  letter-spacing: 0.04em;
  background: #00bcd4;
  color: #ffffff;
  text-transform: uppercase;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
  width: 100%;
}

.auth-button:hover:enabled {
  transform: translateY(-1px);
  box-shadow: 0 5px 14px rgba(0, 188, 212, 0.55);
  background: #04c7e0;
}

.auth-button:disabled {
  opacity: 0.7;
  cursor: default;
  box-shadow: none;
}

.auth-footer {
  margin-top: 14px;
}

.auth-mini {
  width: 100%;
  border: 1px solid rgba(255,255,255,0.2);
  background: transparent;
  color: rgba(255,255,255,0.75);
  border-radius: 12px;
  padding: 10px 12px;
  font-size: 11px;
}
</style>
